export default function () {
    const headers       = document.getElementsByClassName("accordion-item__title"),
          accordionItem = document.getElementsByClassName("accordion-item"),
          accordionItemContent = document.getElementsByClassName("accordion-item__content");
    function accordionEvent() {
        for (let i = 0; i < headers.length; i++) {
            accordionItemContent[i].style.height = 'auto';

            let classList = accordionItem[i].classList;
            classList.remove('active');

            accordionItemContent[i].style.height = 0;

            headers[i].addEventListener("click", () => {
                if ( classList.contains('active') ) {
                    classList.remove('active')
                    accordionItemContent[i].style.height = 0
                } else {
                    classList.add('active')
                    accordionItemContent[i].style.height = accordionItemContent[i].scrollHeight + 'px'
                }
            });
        }
    }
    accordionEvent();
}
